(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('DispositivoDialogController', DispositivoDialogController);

    DispositivoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dispositivo'];

    function DispositivoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dispositivo) {
        var vm = this;

        vm.dispositivo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dispositivo.id !== null) {
                Dispositivo.update(vm.dispositivo, onSaveSuccess, onSaveError);
            } else {
                Dispositivo.save(vm.dispositivo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:dispositivoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
